import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=c544e506&scoped=true&lang=pug&"
import script from "./ImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=c544e506&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c544e506",
  null
  
)

export default component.exports